import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toasted from "vue-toasted";
// import LogRocket from "logrocket";
import VModal from "vue-js-modal";
import "moment-timezone";

// disable logrocket
// LogRocket.init("fpuwuc/insurita");

Vue.use(VModal);

Vue.use(Toasted, {
  iconPack: "mdi",
  theme: "toasted-primary",
  singleton: true
});

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// Enable cypress access to app
// @ts-ignore
if (window.Cypress) {
  // @ts-ignore
  window.app = app;
}
